import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import vuetify from "./plugins/vuetify";
import router from "./router";
import i18n from "./i18n";
import FlagIcon from "vue-flag-icon";
import "@mdi/font/css/materialdesignicons.css";

// Debug i18n in production
if (process.env.NODE_ENV === "production") {
  console.log("i18n initialized with locale:", i18n.global.locale.value);
  console.log("Available locales:", Object.keys(i18n.global.messages.value));
}

createApp(App)
  .use(store)
  .use(FlagIcon)
  .use(vuetify)
  .use(router)
  .use(i18n)
  .mount("#app");
